export const ENTER_KEY = 'Enter';
export const SPACE_KEY = ' ';
